// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  scrollbar-width: thin;
  scrollbar-color: lightgray transparent;
}

._container {
  max-width: 1320px;
  padding: 0 15px 0 0;
  margin: 0 auto;
}

._container--fullbleed {
  width: 100%;
  max-width: 100%;
  padding: 0;
}

.public-route-shell {
  width: 100%;
  min-height: 100vh;
  overflow-x: hidden;
  overflow-y: hidden;
  background: radial-gradient(circle at 10% 10%, rgba(22, 119, 255, 0.16), transparent 38%), radial-gradient(circle at 90% 0%, rgba(74, 144, 226, 0.12), transparent 42%), linear-gradient(160deg, #f7faff 0%, #eef4ff 58%, #f9fbff 100%);
  border-radius: 24px;
}

.public-fullwidth-shell {
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 100vh;
  padding-left: 0;
  overflow-x: hidden;
}

._container {
  max-width: 400px;
}

._container {
  max-width: initial;
}

._container {
  max-width: initial;
  max-width: 705px;
}

._container {
  padding: 0 30px 0 0;
  max-width: initial;
}

._container {
  padding: 0 30px 0 0;
  max-width: initial;
}

._container {
  padding: 0 15px 0 0;
  max-width: initial;
}

._container {
  max-width: initial;
}

._container._container--fullbleed {
  width: 100%;
  max-width: 100%;
  padding: 0;
}

.wrapper {
  margin-bottom: 20px;
}

.wrapper {
  margin-bottom: 40px;
}

.trade_container {
  display: flex;
  justify-content: space-between;
}

.trade_section {
  display: flex;
  flex-direction: column;
  width: 80%;
  padding-left: 15px;
  flex: 1 0;
}

.trade_section--catalog {
  background: #ffffff;
}

.navbarTopLayer {
  position: relative;
}

.navbarTopLayer--catalog {
  position: sticky;
  top: 0;
  z-index: 900;
  background: #ffffff;
  border-radius: 0;
  isolation: isolate;
}

.navbarTopLayer--catalog .cremaNavbar--sticky {
  position: relative;
  top: auto;
  z-index: 1;
}

.home_page_container aside {
  max-width: 100%;
}
.home_page_container .textInfoMenu {
  display: block;
  transform: translateY(0);
  overflow: visible;
  animation: sidebar-text-animation 0.3s forwards;
}

.primary-action-button {
  max-width: -moz-fit-content;
  max-width: fit-content;
  width: 100%;
  border-color: rgb(110, 209, 243) !important;
  background-color: rgb(110, 209, 243) !important;
  color: white !important;
}

.ui-table {
  width: 100%;
  border-collapse: collapse;
}
.ui-table th, .ui-table td {
  padding: 0.5rem;
  vertical-align: top;
}

.ui-table--sm th, .ui-table--sm td {
  padding: 0.25rem;
}

.ui-table--borderless th, .ui-table--borderless td {
  border: 0;
}

.ui-table-cell-sm-only {
  display: none;
}

@media screen and (min-width: 575.98px) {
  .ui-table-cell-sm-only {
    display: table-cell;
  }
}
.summary-block {
  width: 100%;
  max-width: 540px;
  margin-left: auto;
}

.summary-cell-end {
  text-align: right;
}

.cart-block-root {
  display: flex;
}

.cart-block-amount {
  margin-right: 0.5rem;
}

.to-order-badges {
  margin: 0.25rem;
  display: flex;
  gap: 0.25rem;
}

.to-order-badge {
  display: inline-flex;
  padding: 0.2rem 0.4rem;
  border-radius: 0.25rem;
  background: #f1f3f5;
  font-size: 0.75rem;
}

.catalog-filter-actions {
  display: flex;
  justify-content: space-between;
  margin-top: 1rem;
}

.catalog-control-inline {
  display: flex;
  justify-content: flex-end;
  gap: 0.25rem;
}

.catalog-grid-control {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.catalog-grid-sort {
  display: flex;
  flex-direction: row;
  align-items: center;
  color: #6c757d;
  text-align: left;
  white-space: nowrap;
  font-size: 1rem;
}

.catalog-grid-sort-label {
  padding: 5px;
}

.catalog-grid-actions {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}

.chart-grow {
  flex-grow: 1;
}

.chart-center {
  margin: auto;
}

.chart-title {
  width: 100%;
  text-align: center;
}

.search-panel-shell {
  width: 75%;
  margin: 0 auto 1.5rem;
}

.tablist-fill-center {
  height: 100%;
  margin: auto;
}

.catalog-popover-title {
  font-size: 1.75rem;
  margin: 0;
}

.ui-two-column {
  display: grid;
  grid-template-columns: 1fr;
  gap: 1rem;
}

.ui-two-column__item {
  min-width: 0;
}

@media screen and (min-width: 991.98px) {
  .ui-two-column {
    grid-template-columns: 1fr 1fr;
  }
}
.ui-cell-wrap {
  display: block;
  white-space: normal;
  overflow-wrap: anywhere;
}

.data-table-head-top {
  vertical-align: top;
}

.data-table-header-cell {
  text-align: left;
}

.data-table-header-muted {
  color: #6c757d;
}

.data-table-header-cell--center {
  text-align: center;
}

.data-table-header-cell--end {
  text-align: right;
}

.data-table-cell-center {
  text-align: center;
}

.data-table-cell-end {
  text-align: right;
}

.ant-pagination {
  justify-content: center !important;
}`, "",{"version":3,"sources":["webpack://./src/assets/common.sass"],"names":[],"mappings":"AAAA;EACE,qBAAA;EACA,sCAAA;AACF;;AACA;EACE,iBAAA;EACA,mBAAA;EACA,cAAA;AAEF;;AAAA;EACE,WAAA;EACA,eAAA;EACA,UAAA;AAGF;;AADA;EACE,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,uOAAA;EACA,mBAAA;AAIF;;AAFA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;AAKF;;AADA;EACE,gBAAA;AAIF;;AAAA;EACE,kBAAA;AAGF;;AACA;EACE,kBAAA;EACA,gBAAA;AAEF;;AAEA;EACE,mBAAA;EACA,kBAAA;AACF;;AAGA;EACE,mBAAA;EACA,kBAAA;AAAF;;AAGA;EACE,mBAAA;EACA,kBAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAEA;EACE,WAAA;EACA,eAAA;EACA,UAAA;AACF;;AACA;EACE,mBAAA;AAEF;;AACA;EACE,mBAAA;AAEF;;AACA;EACE,aAAA;EACA,8BAAA;AAEF;;AAAA;EACE,aAAA;EACA,sBAAA;EACA,UAAA;EACA,kBAAA;EACA,SAAA;AAGF;;AADA;EACE,mBAAA;AAIF;;AAFA;EACE,kBAAA;AAKF;;AAHA;EACE,gBAAA;EACA,MAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;AAMF;;AAJA;EACE,kBAAA;EACA,SAAA;EACA,UAAA;AAOF;;AAFE;EACE,eAAA;AAKJ;AAJE;EACE,cAAA;EACA,wBAAA;EACA,iBAAA;EACA,+CAAA;AAMJ;;AAJA;EACE,2BAAA;EAAA,sBAAA;EACA,WAAA;EACA,2CAAA;EACA,+CAAA;EACA,uBAAA;AAOF;;AALA;EACE,WAAA;EACA,yBAAA;AAQF;AANE;EACE,eAAA;EACA,mBAAA;AAQJ;;AALE;EACE,gBAAA;AAQJ;;AALE;EACE,SAAA;AAQJ;;AANA;EACE,aAAA;AASF;;AAPA;EACE;IACE,mBAAA;EAUF;AACF;AATA;EACE,WAAA;EACA,gBAAA;EACA,iBAAA;AAWF;;AATA;EACE,iBAAA;AAYF;;AAVA;EACE,aAAA;AAaF;;AAXA;EACE,oBAAA;AAcF;;AAZA;EACE,eAAA;EACA,aAAA;EACA,YAAA;AAeF;;AAbA;EACE,oBAAA;EACA,sBAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;AAgBF;;AAdA;EACE,aAAA;EACA,8BAAA;EACA,gBAAA;AAiBF;;AAfA;EACE,aAAA;EACA,yBAAA;EACA,YAAA;AAkBF;;AAhBA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AAmBF;;AAjBA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;AAoBF;;AAlBA;EACE,YAAA;AAqBF;;AAnBA;EACE,aAAA;EACA,mBAAA;EACA,6BAAA;AAsBF;;AApBA;EACE,YAAA;AAuBF;;AArBA;EACE,YAAA;AAwBF;;AAtBA;EACE,WAAA;EACA,kBAAA;AAyBF;;AAvBA;EACE,UAAA;EACA,qBAAA;AA0BF;;AAxBA;EACE,YAAA;EACA,YAAA;AA2BF;;AAzBA;EACE,kBAAA;EACA,SAAA;AA4BF;;AA1BA;EACE,aAAA;EACA,0BAAA;EACA,SAAA;AA6BF;;AA3BA;EACE,YAAA;AA8BF;;AA5BA;EACE;IACE,8BAAA;EA+BF;AACF;AA9BA;EACE,cAAA;EACA,mBAAA;EACA,uBAAA;AAgCF;;AA9BA;EACE,mBAAA;AAiCF;;AA/BA;EACE,gBAAA;AAkCF;;AAhCA;EACE,cAAA;AAmCF;;AAjCA;EACE,kBAAA;AAoCF;;AAlCA;EACE,iBAAA;AAqCF;;AAnCA;EACE,kBAAA;AAsCF;;AApCA;EACE,iBAAA;AAuCF;;AArCA;EACE,kCAAA;AAwCF","sourcesContent":["body\n  scrollbar-width: thin\n  scrollbar-color: lightgray transparent\n\n._container\n  max-width: 1320px\n  padding: 0 15px 0 0\n  margin: 0 auto\n\n._container--fullbleed\n  width: 100%\n  max-width: 100%\n  padding: 0\n\n.public-route-shell\n  width: 100%\n  min-height: 100vh\n  overflow-x: hidden\n  overflow-y: hidden\n  background: radial-gradient(circle at 10% 10%, rgba(22, 119, 255, 0.16), transparent 38%), radial-gradient(circle at 90% 0%, rgba(74, 144, 226, 0.12), transparent 42%), linear-gradient(160deg, #f7faff 0%, #eef4ff 58%, #f9fbff 100%)\n  border-radius: 24px\n\n.public-fullwidth-shell\n  display: flex\n  flex-direction: column\n  width: 100%\n  min-height: 100vh\n  padding-left: 0\n  overflow-x: hidden\n\n\n@media screen and (min-width: 480px)\n._container\n  max-width: 400px\n\n\n@media screen and (min-width: 575.98px)\n._container\n  max-width: initial\n\n\n@media screen and (min-width: 767.98px)\n._container\n  max-width: initial\n  max-width: 705px\n\n\n@media screen and (min-width: 991.98px)\n._container\n  padding: 0 30px 0 0\n  max-width: initial\n\n\n@media screen and (min-width: 1199.98px)\n._container\n  padding: 0 30px 0 0\n  max-width: initial\n\n@media screen and (min-width: 1439.98px)\n._container\n  padding: 0 15px 0 0\n  max-width: initial\n\n@media screen and (min-width: 1639.98px)\n._container\n  max-width: initial\n\n._container._container--fullbleed\n  width: 100%\n  max-width: 100%\n  padding: 0\n\n.wrapper\n  margin-bottom: 20px\n\n@media screen and (min-width: 991.98px)\n.wrapper\n  margin-bottom: 40px\n\n\n.trade_container\n  display: flex\n  justify-content: space-between\n\n.trade_section\n  display: flex\n  flex-direction: column\n  width: 80%\n  padding-left: 15px\n  flex: 1 0\n\n.trade_section--catalog\n  background: #ffffff\n\n.navbarTopLayer\n  position: relative\n\n.navbarTopLayer--catalog\n  position: sticky\n  top: 0\n  z-index: 900\n  background: #ffffff\n  border-radius: 0\n  isolation: isolate\n\n.navbarTopLayer--catalog .cremaNavbar--sticky\n  position: relative\n  top: auto\n  z-index: 1\n\n\n\n.home_page_container\n  aside\n    max-width: 100%\n  .textInfoMenu\n    display: block\n    transform: translateY(0)\n    overflow: visible\n    animation: sidebar-text-animation 0.3s forwards\n\n.primary-action-button\n  max-width: fit-content\n  width: 100%\n  border-color: rgb(110, 209, 243) !important\n  background-color: rgb(110, 209, 243) !important\n  color: white !important\n\n.ui-table\n  width: 100%\n  border-collapse: collapse\n\n  th, td\n    padding: 0.5rem\n    vertical-align: top\n\n.ui-table--sm\n  th, td\n    padding: 0.25rem\n\n.ui-table--borderless\n  th, td\n    border: 0\n\n.ui-table-cell-sm-only\n  display: none\n\n@media screen and (min-width: 575.98px)\n  .ui-table-cell-sm-only\n    display: table-cell\n\n.summary-block\n  width: 100%\n  max-width: 540px\n  margin-left: auto\n\n.summary-cell-end\n  text-align: right\n\n.cart-block-root\n  display: flex\n\n.cart-block-amount\n  margin-right: 0.5rem\n\n.to-order-badges\n  margin: 0.25rem\n  display: flex\n  gap: 0.25rem\n\n.to-order-badge\n  display: inline-flex\n  padding: 0.2rem 0.4rem\n  border-radius: 0.25rem\n  background: #f1f3f5\n  font-size: 0.75rem\n\n.catalog-filter-actions\n  display: flex\n  justify-content: space-between\n  margin-top: 1rem\n\n.catalog-control-inline\n  display: flex\n  justify-content: flex-end\n  gap: 0.25rem\n\n.catalog-grid-control\n  display: flex\n  flex-direction: row\n  justify-content: space-between\n  align-items: center\n\n.catalog-grid-sort\n  display: flex\n  flex-direction: row\n  align-items: center\n  color: #6c757d\n  text-align: left\n  white-space: nowrap\n  font-size: 1rem\n\n.catalog-grid-sort-label\n  padding: 5px\n\n.catalog-grid-actions\n  display: flex\n  flex-direction: row\n  justify-content: space-around\n\n.chart-grow\n  flex-grow: 1\n\n.chart-center\n  margin: auto\n\n.chart-title\n  width: 100%\n  text-align: center\n\n.search-panel-shell\n  width: 75%\n  margin: 0 auto 1.5rem\n\n.tablist-fill-center\n  height: 100%\n  margin: auto\n\n.catalog-popover-title\n  font-size: 1.75rem\n  margin: 0\n\n.ui-two-column\n  display: grid\n  grid-template-columns: 1fr\n  gap: 1rem\n\n.ui-two-column__item\n  min-width: 0\n\n@media screen and (min-width: 991.98px)\n  .ui-two-column\n    grid-template-columns: 1fr 1fr\n\n.ui-cell-wrap\n  display: block\n  white-space: normal\n  overflow-wrap: anywhere\n\n.data-table-head-top\n  vertical-align: top\n\n.data-table-header-cell\n  text-align: left\n\n.data-table-header-muted\n  color: #6c757d\n\n.data-table-header-cell--center\n  text-align: center\n\n.data-table-header-cell--end\n  text-align: right\n\n.data-table-cell-center\n  text-align: center\n\n.data-table-cell-end\n  text-align: right\n\n.ant-pagination\n  justify-content: center !important\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
